/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategoriaAieaCriteriaDto } from '../models/categoria-aiea-criteria-dto';
import { CategoriaAieaDto } from '../models/categoria-aiea-dto';
import { CategoriaAieaPageDto } from '../models/categoria-aiea-page-dto';
import { CreateCategoriaAieaFormDto } from '../models/create-categoria-aiea-form-dto';
import { UpdateCategoriaAieaFormDto } from '../models/update-categoria-aiea-form-dto';


/**
 * Categorias AIEA
 */
@Injectable({
  providedIn: 'root',
})
export class CategoriasAieaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCategoriasAiea
   */
  static readonly GetCategoriasAieaPath = '/categorias-aiea';

  /**
   * Pesquisar categorias AIEA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategoriasAiea()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoriasAiea$Response(params?: {
    criteria?: CategoriaAieaCriteriaDto;
  }): Observable<StrictHttpResponse<CategoriaAieaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.GetCategoriasAieaPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaPageDto>;
      })
    );
  }

  /**
   * Pesquisar categorias AIEA.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCategoriasAiea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoriasAiea(params?: {
    criteria?: CategoriaAieaCriteriaDto;
  }): Observable<CategoriaAieaPageDto> {

    return this.getCategoriasAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaPageDto>) => r.body as CategoriaAieaPageDto)
    );
  }

  /**
   * Path part for operation createCategoriaAiea
   */
  static readonly CreateCategoriaAieaPath = '/categorias-aiea';

  /**
   * Criar categoria AIEA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCategoriaAiea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCategoriaAiea$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateCategoriaAieaFormDto
  }): Observable<StrictHttpResponse<CategoriaAieaDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.CreateCategoriaAieaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaDto>;
      })
    );
  }

  /**
   * Criar categoria AIEA.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createCategoriaAiea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCategoriaAiea(params?: {

    /**
     * apiRequest
     */
    body?: CreateCategoriaAieaFormDto
  }): Observable<CategoriaAieaDto> {

    return this.createCategoriaAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaDto>) => r.body as CategoriaAieaDto)
    );
  }

  /**
   * Path part for operation getCategoriaAiea
   */
  static readonly GetCategoriaAieaPath = '/categorias-aiea/{id}';

  /**
   * Obter categoria AIEA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategoriaAiea()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoriaAiea$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<CategoriaAieaDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.GetCategoriaAieaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaDto>;
      })
    );
  }

  /**
   * Obter categoria AIEA.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCategoriaAiea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoriaAiea(params: {
    id: number;
  }): Observable<CategoriaAieaDto> {

    return this.getCategoriaAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaDto>) => r.body as CategoriaAieaDto)
    );
  }

  /**
   * Path part for operation updateCategoriaAiea
   */
  static readonly UpdateCategoriaAieaPath = '/categorias-aiea/{id}';

  /**
   * Atualizar categorias AIEA.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCategoriaAiea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCategoriaAiea$Response(params: {
    id: number;
    body?: UpdateCategoriaAieaFormDto
  }): Observable<StrictHttpResponse<CategoriaAieaDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.UpdateCategoriaAieaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaDto>;
      })
    );
  }

  /**
   * Atualizar categorias AIEA.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCategoriaAiea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCategoriaAiea(params: {
    id: number;
    body?: UpdateCategoriaAieaFormDto
  }): Observable<CategoriaAieaDto> {

    return this.updateCategoriaAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaDto>) => r.body as CategoriaAieaDto)
    );
  }

  /**
   * Path part for operation ativarCategoriaAiea
   */
  static readonly AtivarCategoriaAieaPath = '/categorias-aiea/{id}/ativar';

  /**
   * Ativar CategoriaAiea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarCategoriaAiea()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarCategoriaAiea$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<CategoriaAieaDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.AtivarCategoriaAieaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaDto>;
      })
    );
  }

  /**
   * Ativar CategoriaAiea.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarCategoriaAiea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarCategoriaAiea(params: {
    id: number;
  }): Observable<CategoriaAieaDto> {

    return this.ativarCategoriaAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaDto>) => r.body as CategoriaAieaDto)
    );
  }

  /**
   * Path part for operation desativarCategoriaAiea
   */
  static readonly DesativarCategoriaAieaPath = '/categorias-aiea/{id}/desativar';

  /**
   * Desativar CategoriaAiea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarCategoriaAiea()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarCategoriaAiea$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<CategoriaAieaDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriasAieaService.DesativarCategoriaAieaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoriaAieaDto>;
      })
    );
  }

  /**
   * Desativar CategoriaAiea.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarCategoriaAiea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarCategoriaAiea(params: {
    id: number;
  }): Observable<CategoriaAieaDto> {

    return this.desativarCategoriaAiea$Response(params).pipe(
      map((r: StrictHttpResponse<CategoriaAieaDto>) => r.body as CategoriaAieaDto)
    );
  }

}
